var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3H3V6.5H4V4H6.5V3Z",
    fill: "#2AAD75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4V3H11V4H8.5Z",
    fill: "#2AAD75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15.5V3H13V4Z",
    fill: "#2AAD75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3V4H20V6.5H21V3H17.5Z",
    fill: "#2AAD75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.5H20V11H21V8.5Z",
    fill: "#2AAD75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13H20V15.5H21V13Z",
    fill: "#2AAD75"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5H20V20H17.5V21H21V17.5Z",
    fill: "#2AAD75"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21V20H13V21H15.5Z",
    fill: "#2AAD75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V20H8.5V21H11Z",
    fill: "#2AAD75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21V20H4V17.5H3V21H6.5Z",
    fill: "#2AAD75"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5H4V13H3V15.5Z",
    fill: "#2AAD75"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11H4V8.5H3V11Z",
    fill: "#2AAD75"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.5H7V7.5H17V9.5H13V16.5H11V9.5Z",
    fill: "#2AAD75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.e5091dee.svg";
export { ForwardRef as ReactComponent };